import { useCallback, useEffect, useState } from 'react';
import { recaptchaExecuteFailed, recaptchaLoaded, recaptchaLoadFailed, useAnalytics } from '../../common/utils/analytics';
import { hideRecaptchaBadge, loadRecaptcha, RecaptchaError, unloadRecaptcha } from './utils';
export const useInvisibleRecaptcha = ({
  siteKey,
  displayBadge = true,
  analyticsChannel,
  analyticsSource
}) => {
  const triggerEvent = useAnalytics(analyticsChannel, analyticsSource);
  const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);
  const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = useState();
  useEffect(() => {
    const initRecaptcha = async () => {
      try {
        await loadRecaptcha(siteKey);
        if (!displayBadge) {
          hideRecaptchaBadge(siteKey);
        }
        setIsRecaptchaLoaded(true);
        triggerEvent(recaptchaLoaded);
        setRecaptchaLoadErrorReason(undefined);
      } catch (err) {
        const errorMessage = String(err);
        triggerEvent(recaptchaLoadFailed, errorMessage);
        setRecaptchaLoadErrorReason(errorMessage);
      }
    };
    initRecaptcha();
    return () => {
      unloadRecaptcha(siteKey);
      setRecaptchaLoadErrorReason(undefined);
    };
  }, [displayBadge, siteKey, triggerEvent]);
  const getRecaptchaToken = useCallback(async action => {
    try {
      var _window, _window$grecaptcha, _window$grecaptcha$en;
      if (!isRecaptchaLoaded || !((_window = window) !== null && _window !== void 0 && (_window$grecaptcha = _window.grecaptcha) !== null && _window$grecaptcha !== void 0 && (_window$grecaptcha$en = _window$grecaptcha.enterprise) !== null && _window$grecaptcha$en !== void 0 && _window$grecaptcha$en.execute)) {
        throw new RecaptchaError('Execute function not ready');
      }
      return await window.grecaptcha.enterprise.execute(siteKey, {
        action
      });
    } catch (err) {
      triggerEvent(recaptchaExecuteFailed, String(err));
      throw err;
    }
  }, [isRecaptchaLoaded, siteKey, triggerEvent]);
  return {
    isRecaptchaLoaded,
    getRecaptchaToken,
    recaptchaLoadErrorReason
  };
};